module.exports = __webpack_public_path__ + "assets/img/yang_text.45893ebe.png";